import { Expose, Type } from 'class-transformer';
import { Model } from './model';
import { AgePreference } from './age-preference-model';
import { EducationLevelPreference } from './education-level-preference-model';
import { EducationPathPreference } from './education-path-preference-model';

export class TeacherPreferences extends Model {
  @Expose({ name: 'agePreferance' })
  @Type(() => AgePreference)
  agePreference: AgePreference;
  @Expose({ name: 'educationLevelPreferance' })
  @Type(() => EducationLevelPreference)
  educationLevelPreference: EducationLevelPreference;
  @Expose({ name: 'pathPreferance' })
  @Type(() => EducationPathPreference)
  pathPreference: EducationPathPreference;
}
